















































import Vue from 'vue'
export default Vue.extend({
  name: "AppFormField",
  props: {
    field: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      value: undefined
    }
  },
  methods: {
    // fieldChange(event) {
    //   // this.$emit('change', event.target.value)
    // }
  },
  created() {
    this.value = this.field.value
  },
  watch: {
    value(value) {
      this.$emit('change', value)
    }
  }
})
